import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import VideoCard from "@/components/base/VideoCard";
import EmptyState from "@/components/base/EmptyState";
import { usePageMeta } from "@/hooks/usePageMeta";
import { getTopicById, getVideosByIds } from "@/utils/video";

export default function TopicPage() {
  const { topicId = "" } = useParams();
  const topic = getTopicById(topicId);
  const videos = topic ? getVideosByIds(topic.videoIds) : [];

  usePageMeta(
    topic ? `${topic.title} - 专题合集 - 精品视频` : "专题合集 - 精品视频",
    topic ? `${topic.title}：${topic.intro}` : "精品视频专题合集，集中浏览同类推荐内容。",
  );

  if (!topic) {
    return (
      <div className="w-full px-4 md:px-8 pt-24 md:pt-28 pb-16">
        <EmptyState
          icon="ri-bookmark-3-line"
          title="专题不存在"
          description="你访问的专题可能已被移除，去首页看看其他精彩合集吧。"
          actionLabel="返回首页"
          actionTo="/"
        />
      </div>
    );
  }

  return (
    <div className="w-full">
      <section className="relative w-full h-[280px] md:h-[340px]">
        <img
          src={topic.cover}
          alt={`${topic.title} 专题主图`}
          title={`${topic.title} - 专题合集在线观看`}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/70 to-primary-950/50" />
        <div className="absolute inset-0 flex items-end">
          <div className="w-full px-4 md:px-8 pb-8">
            <div>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-secondary-500 text-background-50 text-xs font-medium mb-3">
                <i className="ri-bookmark-3-line" />
                专题合集
              </span>
              <h1 className="text-2xl md:text-4xl font-black text-background-50">{topic.title}</h1>
              <p className="mt-2 text-sm md:text-base text-background-200 max-w-2xl leading-relaxed">{topic.intro}</p>
              <p className="mt-2 text-xs md:text-sm text-secondary-300">共收录 {videos.length} 部内容 · 持续更新</p>
            </div>
          </div>
        </div>
      </section>

      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: topic.title }]} />

        <div className="mt-6">
          {videos.length === 0 ? (
            <EmptyState icon="ri-time-line" title="专题内容正在更新" description="该专题的内容正在筹备中，敬请期待。" />
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
              {videos.map((v, i) => (
                <VideoCard key={v.id} video={v} index={i} />
              ))}
            </div>
          )}
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-home-4-line" />
            回到首页
          </Link>
          <Link
            to="/category/drama"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-200 bg-background-50 text-foreground-700 text-sm font-semibold hover:border-primary-300 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-apps-2-line" />
            浏览更多分类
          </Link>
        </div>
      </div>
    </div>
  );
}